export default __webpack_public_path__ + "static/stats_1_ru-25100d85afcaf97161eebea8e4fe9304.png";